import React, { Component } from 'react'
import '../card.css'
import { setColor } from '../../../../store/actions/resultInfo'

class Card extends Component {

    async handleClick(){
        let c = this.props.color
        if(this.props.color[0] === "#")
            c = this.props.color.slice(1, this.props.color.length)
        await setColor(c)
        this.props.history.push("/type")
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} class="card-outer-container color-card-outer-container">
                <div
                    class="color-card-inner-container"
                    style={
                        this.props.color === "#000"
                            ?
                            { backgroundColor: this.props.color, border: "1px solid white",  }
                            :
                            { background: this.props.background ? this.props.background : "none", backgroundColor: this.props.color, }}
                >
                </div>
            </div>
        )
    }
}

export default Card